import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, vShow as _vShow, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/sound/microphone.png'
import _imports_1 from '@/assets/sound/audioSel.png'
import _imports_2 from '@/assets/aivoice/ico_chuantouxiang.svg'
import _imports_3 from '@/assets/sound/ico_off.png'
import _imports_4 from '@/assets/sound/ico_on.png'
import _imports_5 from '@/assets/sound/icon_tianjiasel.png'
import _imports_6 from '@/assets/sound/play2.png'
import _imports_7 from '@/assets/sound/pause2.svg'
import _imports_8 from '@/assets/sound/load.svg'
import _imports_9 from '@/assets/svg/loding2.gif'


const _hoisted_1 = { class: "cloneTimbre" }
const _hoisted_2 = { class: "cloneTimbreInner" }
const _hoisted_3 = { class: "cloneLeft" }
const _hoisted_4 = { class: "cloneLeftInner" }
const _hoisted_5 = { class: "topInner" }
const _hoisted_6 = { class: "btnInner" }
const _hoisted_7 = { class: "cloneRight" }
const _hoisted_8 = { class: "cloneRightTop" }
const _hoisted_9 = { class: "topRowOne" }
const _hoisted_10 = { class: "topRowOneImg" }
const _hoisted_11 = { class: "imgBox" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "inputBox" }
const _hoisted_14 = { class: "topRowTwo" }
const _hoisted_15 = { class: "rowTwoInput" }
const _hoisted_16 = { class: "topRowThree" }
const _hoisted_17 = { class: "topRowCommon" }
const _hoisted_18 = { class: "topRowCommonInner" }
const _hoisted_19 = { class: "resolution" }
const _hoisted_20 = { class: "topRowCommon" }
const _hoisted_21 = { class: "topRowCommonInner" }
const _hoisted_22 = { class: "topRowFour" }
const _hoisted_23 = { class: "sliderBox" }
const _hoisted_24 = { class: "numBox" }
const _hoisted_25 = { class: "cloneRightText" }
const _hoisted_26 = { class: "cloneRightTextInput" }
const _hoisted_27 = { class: "cloneRightTextInfo" }
const _hoisted_28 = {
  src: _imports_5,
  alt: ""
}
const _hoisted_29 = { class: "cloneRightBtm" }
const _hoisted_30 = { class: "cloneRightPlay" }
const _hoisted_31 = { class: "clonePlay" }
const _hoisted_32 = { class: "loadBox" }
const _hoisted_33 = ["src"]
const _hoisted_34 = {
  key: 0,
  class: "maskTxt"
}
const _hoisted_35 = { class: "maskTxtBox" }
const _hoisted_36 = { class: "maskTxt" }

import { ref, onMounted,getCurrentInstance,onUnmounted } from 'vue'
import type { UploadInstance, UploadProps, UploadRawFile } from 'element-plus'
import { ElMessage, ElMessageBox, ElSwitch } from "element-plus";
import { WarningFilled, Plus } from "@element-plus/icons-vue";
import infoText from '../commonPage/infoText.vue'
import slider from '../commonPage/slider.vue'
import { useRouter, useRoute } from 'vue-router';
import depotApi from "@/api/sound/depot.ts";
// 引入录音组件
import recordPage from './recordPage.vue';
// 
import uploadPage from './uploadPage.vue';
import Auth from "@/api/Auth";
import FetchRequest from "@/api/FetchRequest";

export default /*@__PURE__*/_defineComponent({
  __name: 'cloneTimbre',
  setup(__props) {

const upload = ref<UploadInstance>()
const { push, currentRoute } = useRouter();
// 接口引入
const token = Auth.getToken();
let { proxy } = getCurrentInstance();
// 参数设置
const isRecord=ref(true)//是否tab在录音
const tabSelstyle={
    'color':'#fff'
}
const showlodaing=ref(false)//加载效果
const uploadPageRef=ref()//音频上传组件
const soundChange=ref(0)//变声
const soundtall=ref(true)//音高
const samplingRate=ref(40)
const rateStyle={
    'background': 'rgba(238,251,255,0.25)',
    'color':'rgba(255, 255, 255, .8)'
}
const imageUrl=ref('')//头像
const roleName=ref('')//名称
const intro=ref('')
const demoText=ref('亲爱的用户，感谢您使用一二三克隆音色服务。我们致力于为您提供最自然、最逼真的语音合成体验，让您的声音在数字世界中焕发独特魅力。')
const checked=ref(false)//是否阅读须知
const disabledTo=ref(true)//禁止勾选
const openTextShow=ref(false)//条例是否显示
const trainingNum=ref(80) //训练次数
const avatar=ref('')
const urlListening=ref('')//试听地址
const audioRef=ref()
const isPlay=ref(false)
const loadImg=ref(false)//试听加载
const avatarFile=ref()
const isSave=ref(false)//
const recordRef=ref()
// 打开相关条例
const openText=()=>{
    openTextShow.value=true
}
// 已阅读
const okRun=()=>{
    openTextShow.value=false
    disabledTo.value=false
    checked.value=true
}
// 上传头像
const handleChangeimg = (file: any, fileList: any) => {
   
    const files = file[0] as UploadRawFile
    imageUrl.value = URL.createObjectURL(file.raw!)
    avatarFile.value = file.raw
    
    const formDatas = new FormData();
    formDatas.append('file',file.raw);
    formDatas.append('businessType','avatar');
    formDatas.append('parentId',0);
    const option = {
        // host: FetchRequest.getHost(),
        method: 'post',
        headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + token,
        },
        data: {
            access_token: Auth.getToken(),
            name: "file",
        },
        body: formDatas
    };

    fetch(FetchRequest.getHost() + '/ai/voice/file/file', option)
        .then(function (response) {
            if (response.status == 200) {
                return response.json()
            }
        }).then(data=> {
            
            if (data.code == 200) {
                
                avatar.value=data.data.url
            } else {
                ElMessage({
                    type: 'error',
                    message: data.msg,
                })
            }
            

        })
}
// 总训练次数
const updataTrainingNum=(num: number)=>{
    trainingNum.value = num;
}
//  克隆试听
const funListening=()=>{
     if(urlListening.value!=''){
        isPlay.value=true
        audioRef.value?.play()
        return
    }
    loadImg.value=true
    if(isRecord.value){
        console.log('克隆试听----------录音')
        recordRef.value.updataRecordingListening()
    }else{
        console.log('克隆试听----------上传')
        uploadPageRef.value?.submiltFile()
    }
}
// 文件上传返回数据--试听
const listenFun=(data:any)=>{
    console.log(data)
    
    updataListening(data[1])
}
const errListen=()=>{
    loadImg.value=false
}
const updataListening=(data:string)=>{
            // urlListening.value='Algorithm/tts/ai/voice/changed/2025/10/16/qefndkbbtzdsndp.wav'
           
            // setTimeout(()=>{
            //     loadImg.value=false
            //     isPlay.value=true
            //     audioRef.value?.play()
            // },2000)
    depotApi.tryListening(data,demoText.value).then(res=>{
        console.log(res)
        if(res.code==200){
            urlListening.value=res.msg
          
            setTimeout(()=>{
                loadImg.value=false
                isPlay.value=true
                audioRef.value?.play()
            },2000)
            
        }else{
            loadImg.value=false
        }
        
    }).catch(err=>{
        showlodaing.value=false
        loadImg.value=false
    })
}
const progressAudio=(e)=>{
    console.log(e)
}
// 暂停播放
const audioStop=()=>{
    isPlay.value=false
    audioRef.value?.pause()
}
const updateCurrentTime = () => {
   
        isPlay.value=false
        audioRef.value?.pause()
 
}
// 保存角色
const saveVoice=()=>{
    // 
    if(imageUrl.value==''){
        ElMessage({
            type: 'error',
            message: '请上传角色头像' ,
        })
        return
    }
    if(!checked.value){
        ElMessage({
            type: 'error',
            message: '请阅读版权说明并同意' ,
        })
        return
    }

    if(isRecord.value){
        showlodaing.value=true
        recordRef.value.updataRecording()
    }else{
        showlodaing.value=true
        isSave.value=true
        uploadPageRef.value?.submiltFile()
    }

}
const saveFun=(data:any)=>{
        let param={
            "epoch":trainingNum.value,
            "samplingRate":samplingRate.value,
            "tone": soundtall.value?0:1
        }
        depotApi.addDepot(roleName.value,avatar.value,demoText.value,intro.value,param,soundChange.value,[data[0]]).then(res=>{
           
            showlodaing.value=false
            push('/index/soundTimbre')
        }).catch(err=>{
            showlodaing.value=false
        })
}
// 录音上传返回
const updataRecord=(data:string)=>{
    // loadImg.value=true
    let param={
        "epoch":trainingNum.value,
        "samplingRate":samplingRate.value,
        "tone": soundtall.value?0:1
    }
    depotApi.addDepot(roleName.value,avatar.value,demoText.value,intro.value,param,soundChange.value,[data]).then(res=>{
        
        showlodaing.value=false
        push('/index/soundTimbre')
    }).catch(err=>{
            showlodaing.value=false
     })
}


return (_ctx: any,_cache: any) => {
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "topInnerTab",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (isRecord.value=true), ["stop"]))
            }, [
              _cache[14] || (_cache[14] = _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              }, null, -1)),
              _createElementVNode("span", {
                class: "",
                style: _normalizeStyle(isRecord.value?tabSelstyle:'')
              }, "录音", 4)
            ]),
            _createElementVNode("div", {
              class: "topInnerTab",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (isRecord.value=false), ["stop"]))
            }, [
              _cache[15] || (_cache[15] = _createElementVNode("img", {
                src: _imports_1,
                alt: ""
              }, null, -1)),
              _createElementVNode("span", {
                style: _normalizeStyle(!isRecord.value?tabSelstyle:'')
              }, " 上传音频", 4)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            (isRecord.value==true)
              ? (_openBlock(), _createBlock(recordPage, {
                  key: 0,
                  businessType: 'cloneVoice',
                  ref_key: "recordRef",
                  ref: recordRef,
                  onAudioChange: _cache[2] || (_cache[2] = ($event: any) => (urlListening.value='')),
                  onUpdataRecord: updataRecord,
                  onUpdataListening: updataListening,
                  onErrListen: errListen
                }, null, 512))
              : _createCommentVNode("", true),
            (isRecord.value==false)
              ? (_openBlock(), _createBlock(uploadPage, {
                  key: 1,
                  ref_key: "uploadPageRef",
                  ref: uploadPageRef,
                  onListenFun: listenFun,
                  onAudioChange: _cache[3] || (_cache[3] = ($event: any) => (urlListening.value='')),
                  onErrListen: errListen,
                  onSaveFun: saveFun,
                  isSave: isSave.value
                }, null, 8, ["isSave"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "topRowTitle" }, "音色", -1)),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_el_upload, {
                  class: "avatar-uploader",
                  action: "#",
                  ref: "uploadRefimg",
                  "show-file-list": false,
                  "on-change": handleChangeimg,
                  "auto-upload": false
                }, {
                  default: _withCtx(() => [
                    (imageUrl.value)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: imageUrl.value,
                          class: "avatar"
                        }, null, 8, _hoisted_12))
                      : _createCommentVNode("", true),
                    _cache[16] || (_cache[16] = _createElementVNode("img", {
                      src: _imports_2,
                      class: "imgBoxBtn"
                    }, null, -1))
                  ]),
                  _: 1
                }, 512)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "请输入音色名称",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((roleName).value = $event))
                }, null, 512), [
                  [_vModelText, roleName.value]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "topRowTitle" }, "介绍", -1)),
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "请输入",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((intro).value = $event))
              }, null, 512), [
                [_vModelText, intro.value]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "rowTitle" }, "启用变声功能", -1)),
            _createVNode(_unref(ElSwitch), {
              modelValue: soundChange.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((soundChange).value = $event)),
              size: "small",
              "active-value": "1",
              "inactive-value": "0",
              style: {"--el-switch-on-color":"#17B067","--el-switch-off-color":"#4E4E4F"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "rowTitle" }, "采样率", -1)),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", {
                  class: "resolutionOne",
                  style: _normalizeStyle(samplingRate.value==40?rateStyle:''),
                  onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (samplingRate.value=40), ["stop"]))
                }, "40K", 4),
                _createElementVNode("div", {
                  class: "resolutionOne",
                  style: _normalizeStyle(samplingRate.value==48?rateStyle:''),
                  onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (samplingRate.value=48), ["stop"]))
                }, "48K", 4)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "rowTitle" }, "训练音高", -1)),
              _withDirectives(_createElementVNode("img", {
                src: _imports_3,
                alt: "",
                onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (soundtall.value=true), ["stop"]))
              }, null, 512), [
                [_vShow, !soundtall.value]
              ]),
              _withDirectives(_createElementVNode("img", {
                src: _imports_4,
                alt: "",
                onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (soundtall.value=false), ["stop"]))
              }, null, 512), [
                [_vShow, soundtall.value]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "rowTitle" }, "总训练次数", -1)),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(slider, {
                min: 0,
                max: 100,
                num: trainingNum.value,
                onUpdataNum: updataTrainingNum
              }, null, 8, ["num"]),
              _createElementVNode("div", _hoisted_24, _toDisplayString(trainingNum.value), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _cache[25] || (_cache[25] = _createElementVNode("div", { class: "cloneRightTextTitle" }, " 试听文本 ", -1)),
          _createElementVNode("div", _hoisted_26, [
            _withDirectives(_createElementVNode("textarea", {
              placeholder: "请输入",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((demoText).value = $event)),
              onChange: _cache[12] || (_cache[12] = ($event: any) => (urlListening.value=""))
            }, null, 544), [
              [_vModelText, demoText.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", {
              class: "checkTextInfo",
              onClick: _withModifiers(openText, ["stop"])
            }, [
              _withDirectives(_createElementVNode("span", null, null, 512), [
                [_vShow, !checked.value]
              ]),
              _withDirectives(_createElementVNode("img", _hoisted_28, null, 512), [
                [_vShow, checked.value]
              ])
            ]),
            _cache[23] || (_cache[23] = _createElementVNode("span", { style: {"color":"rgba(255, 255, 255, .6)"} }, "已知悉并同意", -1)),
            _cache[24] || (_cache[24] = _createElementVNode("b", null, "《声音克隆服务版权声明》", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _withDirectives(_createElementVNode("img", {
                src: _imports_6,
                alt: "",
                onClick: _withModifiers(funListening, ["stop"])
              }, null, 512), [
                [_vShow, !isPlay.value && !loadImg.value]
              ]),
              _withDirectives(_createElementVNode("img", {
                src: _imports_7,
                alt: "",
                onClick: _withModifiers(audioStop, ["stop"])
              }, null, 512), [
                [_vShow, isPlay.value && !loadImg.value]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_32, _cache[26] || (_cache[26] = [
                _createElementVNode("img", {
                  src: _imports_8,
                  alt: "",
                  class: "loadBoxImg"
                }, null, -1)
              ]), 512), [
                [_vShow, loadImg.value]
              ]),
              _createElementVNode("audio", {
                src: _unref(proxy).getimgUrlVoice + '/' + urlListening.value,
                controls: "",
                ref_key: "audioRef",
                ref: audioRef,
                onEnded: updateCurrentTime,
                style: {"display":"none"}
              }, null, 40, _hoisted_33),
              _cache[27] || (_cache[27] = _createElementVNode("span", null, "试听", -1))
            ]),
            _createElementVNode("div", {
              class: "cloneSave",
              onClick: _withModifiers(saveVoice, ["stop"])
            }, " 保存 ")
          ])
        ])
      ])
    ]),
    (openTextShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createVNode(infoText, {
              onCloseThis: _cache[13] || (_cache[13] = ($event: any) => (openTextShow.value = false)),
              onOkRun: okRun
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_36, _cache[28] || (_cache[28] = [
      _createElementVNode("div", { class: "maskBox" }, [
        _createElementVNode("img", {
          src: _imports_9,
          style: {"width":"90px","height":"90px"}
        }),
        _createElementVNode("span", null, "正在加载资源中，请稍候...")
      ], -1)
    ]), 512), [
      [_vShow, showlodaing.value]
    ])
  ]))
}
}

})